import { render, staticRenderFns } from "./RelationModule.vue?vue&type=template&id=473b7bc1&scoped=true"
import script from "./RelationModule.vue?vue&type=script&lang=js"
export * from "./RelationModule.vue?vue&type=script&lang=js"
import style0 from "./RelationModule.vue?vue&type=style&index=0&id=473b7bc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473b7bc1",
  null
  
)

export default component.exports